import { connect } from 'react-redux';
import Webhooks from './Webhooks';
import { AppState } from '../../redux/store';
import { deleteWebhooksRequest, webhooksRequest } from '../../redux/actions/webhooks';
import { selectTotalWebhooks, selectWebhooks, selectWebhooksRequestStatus } from '../../redux/selectors/webhooks';
import { getBuilderId } from "../../redux/selectors/auth";

const mapStateToProps = (state: AppState) => ({
  webhooks: selectWebhooks(state),
  webhooksTotal: selectTotalWebhooks(state),
  loading: selectWebhooksRequestStatus(state),
  builderId: getBuilderId(state),
});

const mapDispatchToProps = {
  loadWebhooks: webhooksRequest,
  deleteWebhooks: deleteWebhooksRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Webhooks);
